export const API_URL = `${process.env.REACT_APP_API_BASEURL}`;
export const AUTH_SERVER_API_URL = `${process.env.REACT_APP_AUTH_SERVER_API_BASEURL}`;
export const ASSETS_BASE_URL = `${process.env.REACT_APP_AWS_ASSETS}`;

export const GUID_REGEX = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/;
